function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e4) { throw _e4; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e5) { didErr = true; err = _e5; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

import { logger as N } from "../../shared-lib/index.js";
import { BRAZE_MUST_BE_INITIALIZED_ERROR as p } from "../common/constants.js";
import r from "../managers/braze-instance.js";
import { BRAZE_ACTIONS as oo, getDecodedBrazeAction as eo } from "../util/braze-actions.js";
import ro from "../util/browser-detector.js";
import { OperatingSystems as so } from "../util/device-constants.js";
import { BRAZE_ACTION_URI_REGEX as to, isValidBrazeActionJson as io } from "../util/validation-utils.js";
import { WindowUtils as no } from "../util/window-utils.js";
import { getUser as ao } from "./get-user.js";
export function _handleBrazeAction(o, e, s) {
  if (r.rr()) if (to.test(o)) {
    var _e = eo(o);

    if (!_e) return;

    var _s = function _s(o) {
      if (!io(o)) return void N.error("Decoded Braze Action json is invalid: ".concat(JSON.stringify(o, null, 2)));
      var e = oo.properties.type,
          t = oo.properties.eo,
          i = oo.properties.so,
          n = o[e];

      if (n === oo.types.io) {
        var _e2 = o[t];

        var _iterator = _createForOfIteratorHelper(_e2),
            _step;

        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var _o = _step.value;

            _s(_o);
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
      } else {
        var _e3 = o[i];

        var _s2, _t;

        switch (n) {
          case oo.types.logCustomEvent:
            import("./log-custom-event.js").then(function (_ref) {
              var logCustomEvent = _ref.logCustomEvent;
              r.nt() ? (_t = Array.prototype.slice.call(_e3), logCustomEvent.apply(void 0, _toConsumableArray(_t))) : N.error(p);
            });
            break;

          case oo.types.requestPushPermission:
            import("../Push/request-push-permission.js").then(function (_ref2) {
              var requestPushPermission = _ref2.requestPushPermission;
              r.nt() ? "Safari" === ro.browser && ro.OS === so.ao ? window.navigator.standalone && requestPushPermission() : requestPushPermission() : N.error(p);
            });
            break;

          case oo.types.setEmailNotificationSubscriptionType:
          case oo.types.setPushNotificationSubscriptionType:
          case oo.types.setCustomUserAttribute:
          case oo.types.addToSubscriptionGroup:
          case oo.types.removeFromSubscriptionGroup:
          case oo.types.addToCustomAttributeArray:
          case oo.types.removeFromCustomAttributeArray:
            if (_s2 = ao(), _s2) {
              var _s3;

              (_s3 = _s2)[n].apply(_s3, _toConsumableArray(Array.prototype.slice.call(_e3)));
            }

            break;

          case oo.types.co:
          case oo.types.mo:
            _t = Array.prototype.slice.call(_e3), no.openUri.apply(no, _toConsumableArray(_t));
            break;

          default:
            N.info("Ignoring unknown Braze Action: ".concat(n));
        }
      }
    };

    _s(_e);
  } else no.openUri(o, e, s);
}
export function handleBrazeAction(o, e) {
  _handleBrazeAction(o, e);
}